
<!-- <div class="new-nav">
    <div class="container container_bigscreen">
      <div class="mobile-none">
        <div class="content">
          <p>Huge Discount of <b>INR 5000</b> on all Non-CAT Course of iQuanta. Use Code <b>'MBA2024'</b>.</p>
          <div class="button-wiggle">
          <button [routerLink]="'/details/all-non-cat-course-2025'">Enrol Now</button>
          </div>
        </div>
        </div>
        <div class="desk-none">
            <div class="content d-flex">
                <div class="text-div">
            <p>Huge Discount of <b>INR 5000</b> on all Non-CAT Course of iQuanta. Use Code <b>'MBA2024'</b>.
                </p>
                </div>
                  <span class="button-wiggle">
                    <button [routerLink]="'/details/all-non-cat-course-2025'">Enrol Now</button>
                  </span>
                
            </div>
       </div>
    </div>
  </div>
  <app-subnav [pageType]="'home'"></app-subnav> -->
<app-header [url]="'home'" [pageType]="'home'"></app-header>

<div class="banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="banner-content">
                    <div class="img">
                        <img src="https://media.iquanta.in/ui_images/404.png" alt="">
                    </div>
                    <div class="text">
                        <h2> OOPS!!  </h2>
                        <img src="https://media.iquanta.in/ui_images/%25ile.png" alt="">
                        <h2>not found</h2>
                    </div>
                    <div class="whats-up">
                        <h3 (click)="joinwhatsapp()">Reach us at <span><img src="https://media.iquanta.in/ui_images/whats-up.png" alt=""></span></h3>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="conselling-form new-404-form">
                    <h3>Contact Us</h3>
                    <form [formGroup]="callBackForm">
                        <div class="row">
                            <div class="col-md-4">
                                <mat-form-field appearance="fill" class="mat_form_filed">
                                    <!-- <mat-label>Enter Your Name</mat-label> -->
                                    <input matInput formControlName="name" placeholder="Name">
                                </mat-form-field>
                            </div>

                            <div class="col-md-4">
                                <mat-form-field appearance="fill" class="mat_form_filed">
                                    <!-- <mat-label>Enter Your Phone Number</mat-label> -->
                                    <input matInput formControlName="phone"  placeholder="Mobile Number">
                                </mat-form-field>
                            </div>

                         

                            <div class="col-md-4">
                                <mat-form-field appearance="fill" class="mat_form_filed">
                                    <mat-label>Focus Exam</mat-label>
                                    <mat-select formControlName="course">
                                        <mat-option value="CAT">CAT</mat-option>
                                        <mat-option value="GDPI">GDPI</mat-option>
                                        <mat-option value="GMAT">GMAT</mat-option>
                                        <mat-option value="XAT">XAT</mat-option>
                                        <mat-option value="CMAT">CMAT</mat-option>
                                        <mat-option value="MICAT">MICAT</mat-option>
                                        <mat-option value="CUET PG">CUET PG</mat-option>
                                        <mat-option value="CUET UG">CUET UG</mat-option>
                                        <mat-option value="IPMAT">IPMAT</mat-option>
                                        <mat-option value="CLAT">CLAT</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>


                         
                            <div class="col-md-12 ">
                                <button mat-button (click)="callback()">Submit</button>
                            </div>

                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="other-pages">
                    <div class="head">
                        <h2>Other Pages Link</h2>
                        <h4>Explore the world of learning more easily with <span>iQuanta.</span></h4>
                    </div>
                   <ul>
                    <li>
                        <h5>CAT</h5>
                        <a [routerLink]="'/cat-2025'">Explore Now<i class="bi bi-arrow-right"></i></a>
                    </li>
                    <li>
                        <h5>IPMAT</h5>
                        <a [routerLink]="'/ipmat'">Explore Now<i class="bi bi-arrow-right"></i></a>
                    </li>
                    <li>
                        <h5>CLAT</h5>
                        <a [routerLink]="'/clat-coaching'">Explore Now<i class="bi bi-arrow-right"></i></a>
                    </li>
                    <li>
                        <h5>CUET</h5>
                        <a [routerLink]="'/cuet'">Explore Now<i class="bi bi-arrow-right"></i></a>
                    </li>
                    <li>
                        <h5>GMAT</h5>
                        <a [routerLink]="'/gmat'">Explore Now<i class="bi bi-arrow-right"></i></a>
                    </li>
               

                   </ul>
                   <ul style="margin-top: 20px;">
                    <li>
                        <h5>NMAT</h5>
                        <a [routerLink]="'/nmat-online-coaching'">Explore Now<i class="bi bi-arrow-right"></i></a>
                    </li>
                    <li>
                        <h5>SNAP</h5>
                        <a [routerLink]="'/snap-online-coaching'">Explore Now<i class="bi bi-arrow-right"></i></a>
                    </li>
                    <li>
                        <h5>XAT</h5>
                        <a [routerLink]="'/xat-coaching'">Explore Now<i class="bi bi-arrow-right"></i></a>
                    </li>
                    <li>
                        <h5>IELTS</h5>
                        <a [routerLink]="'/ielts'">Explore Now<i class="bi bi-arrow-right"></i></a>
                    </li>
                   </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<app-footer></app-footer>